import { CalculationModelType, CalculationType } from '../enums';
import { CalculationInputScreeningData } from '../common';
import { CalculationInput } from './calculation-input';

export class CalculationTempData {
    public tempCalculationInput: CalculationInput = new CalculationInput({});
    public tempCalculationModel: CalculationModelType = CalculationModelType.ModelI;
    public tempLocationId: string;
    public tempLocationName: string;
    public tempLocationNumber: string;
    public tempCalculationType: CalculationType;
    public tempScreeningData: CalculationInputScreeningData;
    public isCopyData: boolean;
}
